/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Блочные и строчные элементы</h2>
    <p className={styles.description}>
      <b>Поток документа</b> - порядок расположения элементов на странице. Поток документа относится не к смысловой
      составляющей страницы, а к ее внешнему виду (расположение элементов).
    </p>
    <p className={styles.description}>
      Есть набор правил, которым подчиняются все элементы находящиеся в потоке документа:
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Вертикально поток документа протекает сверху вниз. По умолчанию, чем раньше в коде расположен тег, тем выше он
        расположен на странице. То есть по умолчанию, элементы будут находится на странице в том порядке, в котором они
        указаны в HTML-документе.
      </li>
      <li className={styles.list__item}>
        Горизонтально поток документа протекает слева направо (или справа налево, для восточных стран). Элементы
        занимают так называемые строки, как буквы на листе в линейку. В строке элементы располагаются слева направо (по
        умолчанию), когда ширины строки не хватает для вмещения содержимого элемента, происходит перенос на следующую
        строку.
      </li>
    </ul>
    <p className={styles.description}>
      <b>Блочные элементы</b> — характеризуются тем, что занимают всю доступную ширину внутри блока-родителя, высота
      элемента определяется его содержимым (если явно не указана), и он всегда начинается с новой строки. Визуально это
      прямоугольные области, идущие друг за другом сверху вниз.
    </p>
    <p className={styles.description}>
      <b>Строчные элементы</b> — элементы веб-страницы, которые являются непосредственной частью другого элемента,
      например, текстового абзаца. В основном они используются для изменения вида текста или его логического выделения.
      Занимают по ширине и высоте размеры по своему контенту и будут выстраиваться в одну строку до тех пор, пока в
      строке хватит места, после чего начнут перепрыгивать на следующую и заполнять ее.
    </p>
    <iframe
      height="300"
      scrolling="no"
      title="rotman_html_1_5"
      src="https://codepen.io/rotmanyan/embed/KKXKKGd?default-tab=html%2Cresult&editable=true&theme-id=dark"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
    <p className={styles.notificationWarn}>
      Всегда во время верстки думайте о типе создаваемого элемента, это поможет избежать грубых ошибок и сделает процесс
      верстки более осознанным. Узнать тип тега вы можете в спецификации или справочниках.
    </p>
  </section>
))
